export default __webpack_public_path__ + "static/rudraksh-pareek-26d646f3b325a78719bcce73ba048636.webp";